/**
 * A tenant's own custom domain already implies which tenant this is, so the "organization slug"
 * field (still REQUIRED by the backend - apps/client-api's `loginSchema`/`forgotPasswordSchema`)
 * is only something a visitor to the shared, multi-tenant app.loctopusweb.com/*.pages.dev needs
 * to type. Shared by LoginPage.tsx and ForgotPasswordPage.tsx so both auto-fill/hide it the same
 * way. Keyed off the hostname rather than env/build config so one shared build still serves every
 * tenant correctly - adding another tenant's domain here never requires a rebuild or redeploy.
 */
export const KNOWN_CUSTOM_DOMAIN_TENANT_SLUGS: Record<string, string> = {
  'staff.bobeventsandentertainments.com': 'bob-events',
};

export function knownTenantSlugForHost(): string | undefined {
  return KNOWN_CUSTOM_DOMAIN_TENANT_SLUGS[window.location.hostname];
}
